import { render } from "./Clients.vue?vue&type=template&id=e9a51596&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=e9a51596&lang=scss"
import "./Clients.vue?vue&type=style&index=1&id=e9a51596&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a51596"]])

export default __exports__